import React from 'react';
import '../template-file-css/document-file-template.css';


export const EDU_TCMNeedsAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EDU_TCMNeedsAssessment' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SOCIAL NEEDS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSocialNeeds_1' name='cbSocialNeeds_1' className='add-only' value='SocialNeeds_1' /> Protective Services
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSocialNeeds_2' name='cbSocialNeeds_2' className='add-only' value='SocialNeeds_2' /> Financial Assistance (Living Expenses)</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_3' name='cbSocialNeeds_3' className='add-only' value='SocialNeeds_3' /> Home Aid Services</td>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_4' name='cbSocialNeeds_4' className='add-only' value='SocialNeeds_4' /> Respite Care</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_5' name='cbSocialNeeds_5' className='add-only' value='SocialNeeds_5' /> Shelter Services</td>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_6' name='cbSocialNeeds_6' className='add-only' value='SocialNeeds_6' /> Foster Care</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_7' name='cbSocialNeeds_7' className='add-only' value='SocialNeeds_7' /> Adoption</td>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_8' name='cbSocialNeeds_8' className='add-only' value='SocialNeeds_8' /> Clothing</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_9' name='cbSocialNeeds_9' className='add-only' value='SocialNeeds_9' /> Food</td>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_10' name='cbSocialNeeds_10' className='add-only' value='SocialNeeds_10' /> Housing Issues</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_11' name='cbSocialNeeds_11' className='add-only' value='SocialNeeds_11' /> Independent Living</td>
                        <td className='w-375'><input type='checkbox' id='cbSocialNeeds_12' name='cbSocialNeeds_12' className='add-only' value='SocialNeeds_12' /> Socialization</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSocialNeeds_13' name='cbSocialNeeds_13' className='add-only' value='SocialNeeds_13' /> Recreational (Big Brother, Mentor, YMCA, After School Programs, Scouts, etc.)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSocialNeeds_14' name='cbSocialNeeds_14' className='add-only' value='SocialNeeds_14' /> Other:
                            &nbsp;
                            <input type='text' id='txtSocialNeeds_14Other' name='txtSocialNeeds_14Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>EDUCATIONAL NEEDS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEducationalNeeds_1' name='cbEducationalNeeds_1' className='add-only' value='EducationalNeeds_1' /> Psychological Testing

                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEducationalNeeds_2' name='cbEducationalNeeds_2' className='add-only' value='EducationalNeeds_2' />In Class Support/ Resource Special Education</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbEducationalNeeds_3' name='cbEducationalNeeds_3' className='add-only' value='EducationalNeeds_3' /> Self-Contained Special Education</td>
                        <td className='w-375'><input type='checkbox' id='cbEducationalNeeds_4' name='cbEducationalNeeds_4' className='add-only' value='EducationalNeeds_4' /> Special Schools</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbEducationalNeeds_5' name='cbEducationalNeeds_5' className='add-only' value='EducationalNeeds_5' /> Home-Bound Instruction</td>
                        <td className='w-375'><input type='checkbox' id='cbEducationalNeeds_6' name='cbEducationalNeeds_6' className='add-only' value='EducationalNeeds_6' /> Residential Schools</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbEducationalNeeds_7' name='cbEducationalNeeds_7' className='add-only' value='EducationalNeeds_7' /> Alternative Programs</td>
                        <td className='w-375'><input type='checkbox' id='cbEducationalNeeds_8' name='cbEducationalNeeds_8' className='add-only' value='EducationalNeeds_8' /> General Educational Development (GED)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEducationalNeeds_9' name='cbEducationalNeeds_9' className='add-only' value='EducationalNeeds_9' /> Other:
                            &nbsp;
                            <input type='text' id='txtEducationalNeeds_9others' name='txtEducationalNeeds_9others' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MENTAL HEALTH NEEDS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealthNeeds1' name='cbMentalHealthNeeds1' className='add-only' value='MentalHealthNeeds_1' />Inpatient Hospitalization
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealthNeeds2' name='cbMentalHealthNeeds2' className='add-only' value='MentalHealthNeeds_2' />Residential Treatment Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealthNeeds3' name='cbMentalHealthNeeds3' className='add-only' value='MentalHealthNeeds_3' />Psychological Testing
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealthNeeds4' name='cbMentalHealthNeeds4' className='add-only' value='MentalHealthNeeds_4' />Outpatient Treatment/Counseling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbeMentalHalthNeeds5' name='cbMentalHealthNeeds5' className='add-only' value='MentalHealthNeeds_5' /> Other:
                            &nbsp;
                            <input type='text' id='txtMentalHalthNeeds5Other' name='txtMentalHalthNeeds5Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>HEALTH NEEDS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHealthneeds_1' name='cbHealthneeds_1' className='add-only' value='Healthneeds_1' /> Health Education and Prevention
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHealthneeds_2' name='cbHealthneeds_2' className='add-only' value='Healthneeds_2' />Screening and Assessment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbHealthneeds_3' name='cbHealthneeds_3' className='add-only' value='Healthneeds_3' />Primary Care
                        </td>
                        <td className='w-375'><input type='checkbox' id='cbHealthneeds_4' name='cbHealthneeds_4' className='add-only' value='Healthneeds_4' /> Acute Care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbHealthneeds_5' name='cbHealthneeds_5' className='add-only' value='Healthneeds_5' />Long-Term Care
                        </td>
                        <td className='w-375'><input type='checkbox' id='cbHealthneeds_6' name='cbHealthneeds_6' className='add-only' value='Healthneeds_6' /> Dental Care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbHealthneeds_7' name='cbHealthneeds_7' className='add-only' value='Healthneeds_7' /> Medication Assistance (Financial)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHealthneeds_8' name='cbHealthneeds_8' className='add-only' value='Healthneeds_8' /> Other:
                            &nbsp;
                            <input type='text' id='txtcbHealthneeds_8Other' name='txtcbHealthneeds_8Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>VOCATIONAL NEEDS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVocationalNeeds_1' name='cbVocationalNeeds_1' className='add-only' value='VocationalNeeds_1' /> Career Education
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVocationalNeeds_2' name='cbVocationalNeeds_2' className='add-only' value='VocationalNeeds_2' />Vocational Assessment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbVocationalNeeds_3' name='cbVocationalNeeds_3' className='add-only' value='VocationalNeeds_3' />Job Survival skills Training
                        </td>
                        <td className='w-375'><input type='checkbox' id='cbVocationalNeeds_4' name='cbVocationalNeeds_4' className='add-only' value='VocationalNeeds_4' /> Vocational Skills Training
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbVocationalNeeds_5' name='cbVocationalNeeds_5' className='add-only' value='VocationalNeeds_5' />Work Experiences
                        </td>
                        <td className='w-375'><input type='checkbox' id='cbVocationalNeeds_6' name='cbVocationalNeeds_6' className='add-only' value='VocationalNeeds_6' />Job Finding, Placement & Retention Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbVocationalNeeds_7' name='cbVocationalNeeds_7' className='add-only' value='VocationalNeeds_7' /> Other:
                            &nbsp;
                            <input type='text' id='txtVocationalNeeds_7Other' name='txtVocationalNeeds_7Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ADDITIONAL NEEDS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalNeeds_1' name='cbAdditionalNeeds_1' className='add-only' value='AdditionalNeeds_1' /> Alcohol and Drug Abuse Treatment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdditionalNeeds_2' name='cbAdditionalNeeds_2' className='add-only' value='AdditionalNeeds_2' />Self-Help and Support Groups
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbAdditionalNeeds_3' name='cbAdditionalNeeds_3' className='add-only' value='AdditionalNeeds_3' />Advocacy
                        </td>
                        <td className='w-375'><input type='checkbox' id='cbAdditionalNeeds_4' name='cbAdditionalNeeds_4' className='add-only' value='AdditionalNeeds_4' />Transportation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbAdditionalNeeds_5' name='cbAdditionalNeeds_5' className='add-only' value='AdditionalNeeds_5' />Legal Services
                        </td>
                        <td className='w-375'><input type='checkbox' id='cbAdditionalNeeds_6' name='cbAdditionalNeeds_6' className='add-only' value='AdditionalNeeds_6' />Volunteer Programs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAdditionalNeeds_7' name='cbAdditionalNeeds_7' className='add-only' value='AdditionalNeeds_7' /> Other:
                            &nbsp;
                            <input type='text' id='txtAdditionalNeeds_7Other' name='txtAdditionalNeeds_7Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>




                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Provide a Summary of TCM Needs</span>

                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' className='add-only'></textarea>
                </p>





            </div>
        </form>

    )
}